// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"78":"00bc9992","261":"52528d46","338":"44d3cdce","456":"d5d3bddc","541":"2596fba1","544":"623f4497","576":"ffb51454","753":"5d21ae26","775":"7a96ea60","823":"1403b204","980":"32be45f7"}[chunkId] + ".js";
};